import { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { InviteTableRowType } from '../types';

const InviteEmailHeader: FC = () => {
  const { t } = useTranslation('settings');
  return <>{t('workspaceUsers.columns.email')}</>;
};

export const getInviteEmailColumn = (): ColumnDef<InviteTableRowType> => {
  return {
    accessorKey: 'invitedEmail',
    header: InviteEmailHeader,
    cell: ({ row }) => <div className='text-sm font-medium text-gray-900'>{row.original.invitedEmail}</div>,
  };
};
